import { useEffect, useRef, useState } from 'react';

const Logo = () => (
  <div className="flex items-center gap-2">
    <span className="inline-block w-2 h-6 bg-f1-red rounded-sm" />
    <span className="font-semibold tracking-tight">Splitlap</span>
  </div>
);

const RacePicker = ({ races, selectedSlug, onSelect }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  if (!races || races.length === 0) return null;
  const current = races.find((r) => r.slug === selectedSlug) || races[0];

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-lg bg-f1-surface border border-f1-border px-3 py-1.5 text-sm hover:border-f1-muted transition-colors"
      >
        <span className="text-f1-muted">Race</span>
        <span className="text-f1-text">{current.season} {current.name}</span>
        <span className="text-f1-muted">▾</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-80 max-h-96 overflow-y-auto rounded-lg bg-f1-surface2 border border-f1-border shadow-xl z-20">
          {races.map((r) => (
            <button
              key={r.slug}
              onClick={() => {
                onSelect(r.slug);
                setOpen(false);
              }}
              className={`block w-full text-left px-3 py-2 text-sm hover:bg-f1-surface transition-colors ${
                r.slug === current.slug ? 'bg-f1-surface text-f1-text' : 'text-f1-muted'
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <span>{r.season} — {r.name}</span>
                {r.heldOn && (
                  <span className="text-xs text-f1-muted">{r.heldOn.slice(0, 10)}</span>
                )}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export const TopBar = ({
  races,
  selectedRaceSlug,
  onSelectRace,
  user,
  loading,
  onSignInClick,
  onSignOut,
}) => {
  return (
    <header className="sticky top-0 z-10 bg-f1-bg/80 backdrop-blur border-b border-f1-border">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <Logo />
        <div className="flex items-center gap-3">
          <RacePicker
            races={races}
            selectedSlug={selectedRaceSlug}
            onSelect={onSelectRace}
          />
          {loading ? (
            <span className="text-xs text-f1-muted">…</span>
          ) : user ? (
            <div className="flex items-center gap-2">
              <span className="text-xs text-f1-muted hidden sm:inline">
                {user.email || ''}
              </span>
              <button
                onClick={onSignOut}
                className="text-xs rounded-lg bg-f1-surface border border-f1-border px-3 py-1.5 hover:border-f1-muted transition-colors"
              >
                sign out
              </button>
            </div>
          ) : (
            <button
              onClick={onSignInClick}
              className="text-xs rounded-lg bg-f1-red px-3 py-1.5 font-medium hover:opacity-90 transition-opacity"
            >
              sign in
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
